<template>
  <v-list-item v-if="visible" exact :to="{ name: routeName }">
    <v-list-item-action>
      <v-icon light v-text="icon" class="fa-fw"></v-icon>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title v-text="title"></v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  props: {
    title: String,
    icon: String,
    routeName: String,
    visible: { type: Boolean, default: true }
  }
}
</script>

<style scoped lang="scss">
.v-list {
  .v-list__tile {
    &.v-list__tile--active {
      .v-icon {
        font-weight: 400;
      }

      .v-list__tile__content {
        font-weight: bolder;
      }
    }

    .v-list__tile__action {
      min-width: unset;
      margin-right: 16px;
    }
  }
}
</style>
